import React, { useEffect, useState } from "react";
import "./Product_info.css";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";
import Demo_Product from "../../home/demo_product/Demo_Product";
import Increment_decrement_btn_holder from "../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder";
import { useNavigate } from "react-router-dom";
import Rating from "react-rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories } from "../../../features/master/masterSlice";
import { getHomeBanner } from "../../../features/home/homeSlice";
import { postCart } from "../../../features/cart/cartSlice";
import Demo_ProductCategory from "../../home/demo_product/Demo_ProductCategory";

const Product_info = ({ product, avg_rating }) => {
  const [activeIndex, setActiveIndex] = useState(0); // default first card active

  const products = [
    { name: "Bilona Cow Ghee", imgSrc: "/assets/images/demo_product/ghee.png" },
    { name: "Kalanmak Rice", imgSrc: "/assets/images/demo_product/rice.png" },
    { name: "Desi Tuar Dal", imgSrc: "/assets/images/demo_product/daal.png" },
    {
      name: "Black Turmeric",
      imgSrc: "/assets/images/demo_product/ginger.png",
    },
    {
      name: "Kasturi Haldi",
      imgSrc: "/assets/images/demo_product/termeric.png",
    },
  ];

  const breakpoints = {
    320: { slidesPerView: 3 },
    485: { slidesPerView: 5 },
    768: { slidesPerView: 4 },
    992: { slidesPerView: 4 },
    1024: { slidesPerView: 5 },
  };

  const quantityOptions = Array(4).fill({
    label: "250 ml (Glass Bottle)",
    priceInfo: "₹949 ₹3.79/ml",
  });

  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/product-cart?product_id=${product?.id}`);
  };

  const selectedVariant = product?.Product_Variants?.[activeIndex];

  const category = useSelector((state) => state.master.categories);
  const banner = useSelector((state) => state.home.banners);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllCategories());
    dispatch(getHomeBanner());
  }, [dispatch]);

  //add to cart
  const [quantity, setQuantity] = useState(1);

  const isSignIn = useSelector((state) => state.auth.is_signin);
  const addToCart = async () => {
    try {
      const data = {
        product_id: product.id,
        variant_id: selectedVariant?.id,
        quantity: quantity,
      };
      const res = await dispatch(postCart({ data: data, isSignIn: isSignIn }));

      if (res.meta?.requestStatus === "fulfilled") {
        handleClick();
        if (res?.payload?.data?.success) {
        } else {
        }
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  return (
    <section className="Product_info">
      <div className="text_holder">
        <h4 className="para_secondary_text">{product?.name}</h4>
        <div className="rating_holder">
          <p className="rating_text para_secondary_text">
            <Rating
              className="star_icons para_secondary_text"
              initialRating={Number(avg_rating?.average_rating)}
              emptySymbol={<FontAwesomeIcon icon={farStar} color="#4b0082" />}
              fullSymbol={<FontAwesomeIcon icon={fasStar} color="#4b0082" />}
              fractions={2}
            />
            {Number(avg_rating?.average_rating)} | {avg_rating?.total_counts}{" "}
            Reviews
          </p>
        </div>
        {selectedVariant && (
          <div className="price_holder">
            <h6 className="para_text">
              <span className="discounted_price para_text">
                Rs. {selectedVariant.mrp}
              </span>
              Rs. {selectedVariant.price}{" "}
            </h6>
            <div className="save_div">
              <Green_btn
                btnText={`Save: ${Math.round(
                  ((selectedVariant.mrp - selectedVariant.price) /
                    selectedVariant.mrp) *
                    100
                )}%`}
              />
            </div>

            <span className="mrp_holder">MRP (Inclusive of all taxes)</span>
          </div>
        )}
        {/* <div className="price_holder">
                    <h6>
                        Sale Price: ₹400 <span className="discounted_price">₹599</span>
                    </h6>
                    <Green_btn btnText="Save: 11%" />
                    <span className="mrp_holder">MRP (Inclusive of all taxes)</span>
                </div> */}
      </div>

      <div className="quantity_holder">
        <div className="row">
          {product?.Product_Variants?.map((option, index) => (
            <div
              className="col-sm-4 col-6 mb-3"
              key={index}
              onClick={() => setActiveIndex(index)}
            >
              <div
                className={`quantity_box_holder ${
                  index === activeIndex ? "active" : ""
                }`}
              >
                <div className="info_holder">
                  <h5>{option.name}</h5>
                  <p>₹{option.price}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="banner_img_holder">
        <Swiper
          spaceBetween={10}
          slidesPerView={1}
          modules={[Autoplay]}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
        >
          {banner?.map((val) => (
            <SwiperSlide>
              <div className="img_holder">
                <img
                  className="banner_img"
                  src={process.env.REACT_APP_IMG_URL + val.image}
                  alt="banner"
                />
              </div>
            </SwiperSlide>
          ))}

          {/* <SwiperSlide>
            <div className="img_holder">
              <img
                className="banner_img"
                src={`${process.env.PUBLIC_URL}/assets/images/home/banner/banner_1.png`}
                alt="banner"
              />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="img_holder">
              <img
                className="banner_img"
                src={`${process.env.PUBLIC_URL}/assets/images/home/banner/banner_1.png`}
                alt="banner"
              />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="img_holder">
              <img
                className="banner_img"
                src={`${process.env.PUBLIC_URL}/assets/images/home/banner/banner_1.png`}
                alt="banner"
              />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="img_holder">
              <img
                className="banner_img"
                src={`${process.env.PUBLIC_URL}/assets/images/home/banner/banner_1.png`}
                alt="banner"
              />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="img_holder">
              <img
                className="banner_img"
                src={`${process.env.PUBLIC_URL}/assets/images/home/banner/banner_1.png`}
                alt="banner"
              />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="img_holder">
              <img
                className="banner_img"
                src={`${process.env.PUBLIC_URL}/assets/images/home/banner/banner_1.png`}
                alt="banner"
              />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="img_holder">
              <img
                className="banner_img"
                src={`${process.env.PUBLIC_URL}/assets/images/home/banner/banner_1.png`}
                alt="banner"
              />
            </div>
          </SwiperSlide> */}
        </Swiper>
      </div>

      <div className="prod_description">
            
      </div>

      <div className="btn_holder">
        <div className="add_cart_btn">
          {Number(selectedVariant?.general_stock) >= Number(quantity) ? (
            <Green_btn
              btnText="ADD TO CART"
              product={product}
              onClick={addToCart}
              quantity={quantity}
              setQuantity={setQuantity}
              selectedVariant={selectedVariant}
            />
          ) : (
            <p className="text-danger fw-bold">Out of stock</p>
          )}
        </div>
        {Number(selectedVariant?.general_stock) >= Number(quantity) ? (
          <Increment_decrement_btn_holder
            quantity={quantity}
            setQuantity={setQuantity}
          />
        ) : (
          <></>
        )}
      </div>
    </section>
  );
};

export default Product_info;
